module.exports = __webpack_public_path__ + "img/sup_deposit_ccpayment2.9fd32495.jpg";